<template>

<div class="w-100">

    <div class="container promo-container">  

        <!-- !!! Temporary Solution: Please, remove class "special-plans", when tabs are back !!! -->
        <div v-if='isReady' class="row d-flex justify-content-center special-plans home-plans mb-1"> 

            <!-- Temporary Solution.Should be returned to the previous version  when the client create more plans in the future
            <div v-for='s in subscriptions' v-if='s.c == cat'  
            -->
            <div v-for='s in subscriptions'
                 class="col-lg-4 col-md-8 mb-5 col">                    
                <div class="card card-plan h-100">
                    <div :class="['card-header', { 'main-bck' : s.promo_cost }]">
                        <h4 :class="['text-main text-uppercase', { 'text-white' : s.promo_cost }]" v-if='s.c == 1'>TOP 1%*</h4>
                        <h4 :class="['text-main text-uppercase', { 'text-white' : s.promo_cost }]" v-if='s.c == 2'>2% - 10%*</h4>
                        <h4 :class="['text-main text-uppercase', { 'text-white' : s.promo_cost }]" v-if='s.c == 3'>10% - 100%*</h4>

                        <h5 :class="['text-main text-uppercase mb-0', { 'text-white' : s.promo_cost }]">
                            {{ s.name }}
                        </h5>
                        <span :class="[ s.promo_cost ? 'text-white' : 'text-muted']">
                            {{ s.desc }}
                        </span>
                    </div>

                    <div class="card-body d-flex justify-content-end flex-column align-items-center">

                        <span class="stars text-main">
                            <span :class="['icon icon-star icon-1', {'opacity-4' : s.c == 3 }]"></span> 
                            <span class="icon icon-star icon-2"></span> 
                            <span :class="['icon icon-star icon-3', { 'opacity-4' : s.c == 2 || s.c == 3 }]"></span>
                        </span>

                        <div v-if='s.promo_cost' class="old-price">
                            <s>&dollar; {{ s.cost }}</s>
                        </div>

                        <div class="price">
                            <div class="d-flex align-items-center">
                                <span class="dollar mr-1">
                                    &dollar;
                                </span>
                                <span class="num">
                                    {{ s.promo_cost ? s.promo_cost : s.cost }}
                                </span>
                            </div>
                            <span class="text-muted">
                                duration: {{ s.duration }} days
                            </span>
                        </div>

                        <button @click='selectPlan(s)' 
                                v-if='selected != s.id'
                                type='button' 
                                class="btn btn-primary mt-4">
                            {{ config.buttonText }}
                        </button>
                        
                        <span v-if='selected == s.id' class="selected-plan mt-4 font-weight-bold text-gold">
                            <span class="icon icon-check"></span>
                            Plan selected
                        </span>


                        <!-- Temporary Solution. Should be deleted when the client create more plans in the future -->
                        <p v-if='s.c == 1' class="mb-0 mt-3">The 1% subscriptions grants you full access to all available models.</p>
                        <p v-if='s.c == 2' class="mb-0 mt-3">The 2-10% subscriptions grants you full access to all available models except the once in the 1% category.</p>
                        <p v-if='s.c == 3' class="mb-0 mt-3">The 10-100% subscriptions grants you full access to all available models except the once in the top 1% and top 2-10%.</p>
                        <!-- End Temporary Solution -->
                    </div>                      
                </div>                  
            </div>

        </div>
    </div>
</div>


</template>

<script>
    export default {

        mounted() {
            this.getData();
        },

        created() {
            if( typeof this.conf != 'undefined' ) {

                this.config = Object.assign({}, this.config, this.conf);

            }

            this.checkHash();
        },

        props : ['conf'],

        data() {
            var me = this;

            return {
                isReady : false,
                subscriptions : [],
                selected    : false,
                preSelect   : false,

                config : {
                    buttonText : 'Buy now', 
                    onSelect(s) {
                        return me.defaultClick(s);
                    }
                },

                //cat : 1,
            }
        },

        methods : {

            getData() {

                this.ajax.call('el:gsb', {}, (r) => {
                    
                    if( r.status == 'success' ) {
                        this.subscriptions = r.data;
                        this.isReady = true;

                        //Autoselect first plan
                        if( this.subscriptions.length ) {
                            this.selectPlan( this.subscriptions[0] );
                        }

                        /* Pre select, uncomment when plans are ON

                        if( this.preSelect ) {
                            for( var i in this.subscriptions ) {
                                if( this.subscriptions[i].id == this.preSelect ) {
                                    this.selectPlan( this.subscriptions[i] );
                                    break;
                                }
                            }
                        }

                        */
                    }

                })

            },

            selectPlan( s ) {

                this.selected = s.id;
                this.config.onSelect(s);

            },
 
            defaultClick( s ) {
                if( !this.user ) {
                 
                    location.href = '/register#' + s.id;
                
                } else {

                    location.href = '/aregs/' + s.id;
               
                }

            },

            checkHash() {
                if( location.hash ) {
                    var hash = location.hash.replace('#','');

                    if( !isNaN(hash) ) {
                        this.preSelect = parseInt(hash);
                    }
                }
            }

        }

    }
</script>
